import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { nFormatter } from "../../../Helpers";
import CurrencySymbol from "../../../Components/common/CurrencySymbol";

export const pick = (obj = {}, ...keys) => {
  for (const key of keys) {
    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
  }
  return undefined;
};

export const num = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const pct = (value, digits = 1) => {
  const parsed = num(value);
  return `${parsed.toFixed(digits)}%`;
};

export const formatCurrency = (value, currency = "AED") => {
  const parsed = num(value);
  const amount =
    parsed >= 1000
      ? nFormatter(parsed, 1)
      : parsed.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
  return (
    <>
      <CurrencySymbol currency={currency} withParentheses={false} /> {amount}
    </>
  );
};

export const fullCurrency = (value, currency = "AED") => {
  const parsed = num(value);
  const amount = parsed.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
    <>
      <CurrencySymbol currency={currency} withParentheses={false} /> {amount}
    </>
  );
};

export const fullNumber = (value, digits) => {
  const parsed = num(value);
  if (digits != null) {
    return parsed.toLocaleString(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  }
  return parsed.toLocaleString();
};

export const fullPct = (value, digits = 2) => {
  const parsed = num(value);
  return `${parsed.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
};

export const Tip = ({
  title,
  children,
  className,
  component: Component = "span",
  placement = "top",
  ...rest
}) => {
  const tip =
    title === undefined || title === null || title === "" ? null : title;

  const node = (
    <Component
      className={className}
      {...rest}
      style={{ cursor: tip ? "help" : undefined, ...(rest.style || {}) }}
    >
      {children}
    </Component>
  );

  if (!tip) return node;

  return (
    <Tooltip
      title={
        <span style={{ fontSize: 13, whiteSpace: "pre-line" }}>{tip}</span>
      }
      arrow
      enterDelay={200}
      placement={placement}
    >
      {node}
    </Tooltip>
  );
};

export const WidgetInfo = ({ title }) =>
  title ? (
    <Tip title={title} className="skd-widget-info" component="span">
      <InfoOutlinedIcon className="skd-widget-info-icon" />
    </Tip>
  ) : null;

export const WidgetSkeleton = ({ height = 280 }) => (
  <div className="skd-widget">
    <Skeleton
      variant="text"
      width="50%"
      height={20}
      sx={{ bgcolor: "#e9eaec" }}
    />
    <Skeleton
      variant="rectangular"
      height={height}
      sx={{ bgcolor: "#e9eaec", mt: 2, borderRadius: 1 }}
    />
  </div>
);
